/// <reference types="vite-plugin-svgr/client" />
import { Box, Flex } from '@mantine/core'

import { AddAccount } from '@/components/AddAccount/AddAccount'
import { Disclaimer } from '@/components/Disclaimer/Disclaimer'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import StarIcon from '@/assets/icons/star.svg?react'
import WhistleIcon from '@/assets/icons/whistle.svg?react'

import classes from './NoAccounts.module.css'

export function NoAccounts() {
  return (
    <Flex className={classes.noAccounts}>
      <Box className={classes.wrapper}>
        <StarIcon />

        <Title variant="h1">Let&apos;s get started!</Title>

        <Text align="center">
          In order to have a holistic view of your financial health, we
          recommend connecting all of your financial accounts. As a reminder,
          your private information is only available to you and your planner,
          provided that you grant them permission.
        </Text>

        <Box mt={24}>
          <AddAccount />
        </Box>
      </Box>

      <Box className={classes.disclaimer}>
        <Disclaimer
          description="After adding your accounts, you can book a meeting with your planner to get any of your personal finance questions answered."
          icon={<WhistleIcon />}
          maxWidth={744}
          textVariant="body_1_medium_purple"
        />
      </Box>
    </Flex>
  )
}
